import { CommonModule } from '@angular/common';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentRef, createComponent, EnvironmentInjector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subject, finalize, Subscription, takeUntil } from 'rxjs';
import { MAPBOX_ACESS_TOKEN } from 'app/app.constants';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GeoJSONSource, LngLatBounds, Map, Marker, Popup } from 'mapbox-gl';
import { CapitalizePipe } from 'app/pipes/capitalize/capitalize.pipe';
import { RemoverCaractersEspeciaisPipe } from 'app/pipes/remover-caracters-especiais/remover-caracters-especiais.pipe';
import { MAP_ANIMATION } from 'app/constants/map.constants';
import { EquipamentoPopupBuilder } from 'app/shared/index';
import { DialogInformacoesComponent, DialogLegendaMapaComponent, EncontrarEquipamentosComponent, DialogRastrosComponent, FiltroMapaComponent, OfensoresProdutividadeComponent, LoadingComponent, DialogApontamentosFormComponent, DialogFalhasComponent, ExportarMapasCalorComponent, EncontrarTalhoesComponent, PainelCamadasComponent, VelocimetroMapaComponent } from 'app/components/index';
import { Equipamento, Equipamentos, EquipamentoTelemetria, Operacao, OperacaoPusher, OfensorProdutividade, Arquivo, Arquivos, ArquivosPorTipo, MapaDisponivel, WebsocketTipo, Fazendas, AutonomiasPusher, PosicaoEquipamentoPusher, ApontamentoParadaPusher, FinalizacaoParadaPusher, AlteracaoStatusEquipamentoPusher, ParadaMapa, VelocidadeIdeal } from 'app/interfaces/index';
import { WebsocketService, FazendaService, DatetimeService, EquipamentoService, S3Service, MapaService, SidebarService, CompartilhamentoService, OperacaoService, Trator3dService, MapaCamadasService, ConfiguracaoCamadasMapa, VelocidadeIdealService } from 'app/services/index';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
@Component({
  selector: 'app-mapa',
  standalone: true,
  providers: [],
  imports: [CommonModule, DialogInformacoesComponent, EncontrarEquipamentosComponent, DialogLegendaMapaComponent, DialogRastrosComponent, FiltroMapaComponent, OfensoresProdutividadeComponent, LoadingComponent, ReactiveFormsModule, DialogFalhasComponent, ExportarMapasCalorComponent, EncontrarTalhoesComponent, PainelCamadasComponent, TranslocoModule, RouterLink],
  templateUrl: './mapa.component.html',
  styleUrl: './mapa.component.css'
})
export class MapaComponent implements OnInit, OnDestroy {
  @ViewChild(DialogLegendaMapaComponent) legendaMapaComponent!: DialogLegendaMapaComponent;
  private eventoSub: Subscription | undefined;
  private readonly CANAL: string = `cliente-${localStorage.getItem('clienteId')}`;
  private readonly EVENTO = 'CanalPorClienteEvent';
  private readonly destroy$ = new Subject<void>();
  private popupAtual: Popup | null = null;
  private popupVelocidade: Popup | null = null;
  private velocimetroComponentRef: ComponentRef<VelocimetroMapaComponent> | null = null;
  private idParadaParaSrId: Record<number, number> = {};
  private onZoom!: () => void;
  public map!: Map;
  private currentPitch: number = 30;
  public mapboxAccessToken: string = MAPBOX_ACESS_TOKEN
  public zoom: number = 12;
  public center: [number, number] = [-49.3797, -20.8202,];
  public mapStyle: string = 'mapbox://styles/mapbox/satellite-streets-v11?optimize=true';
  public geojsonSource: any;
  public maxBounds: any;
  public tipoMapaSelecionado = new FormControl<null | string>('rastros');
  public operacaoId: number = Number(localStorage.getItem('operacaoId'));
  public clienteId: string | null = localStorage.getItem('clienteId');
  public get clienteIdNumber(): number {
    return Number(this.clienteId);
  }

  public get dataInicioISO(): string {
    return this.filtrosAplicados?.dataInicio instanceof Date
      ? this.filtrosAplicados.dataInicio.toISOString()
      : (this.filtrosAplicados?.dataInicio || '');
  }

  public get dataFimISO(): string {
    return this.filtrosAplicados?.dataFim instanceof Date
      ? this.filtrosAplicados.dataFim.toISOString()
      : (this.filtrosAplicados?.dataFim || '');
  }
  public atualizacaoAutonomiaInsumo!: AutonomiasPusher;
  public carregandoInformacoesDoEquipamento: string = ''
  public sidebarExpandido: boolean = false;
  public isLegendaMapaAberto: boolean = false;
  public dialogLegendas: boolean = false;
  public exibirModalEncontrarEquipamento: boolean = true;
  public exibirModalEncontrarTalhoes: boolean = true;
  public exibirPainelCamadas: boolean = true;
  public carregandoOfensoresProdutividade: boolean = true;
  public equipamentoLoading: boolean = false;
  public carregandoTalhoes: boolean = false;
  public carregandoShapes: boolean = false;
  public carregandoEquipamentos: boolean = false;
  private clienteIdShapesCarregado: number | null = null;
  public carregandoMapasDisponiveis: boolean = true;
  public exportarMapaCalorModal: boolean = false;
  public carregandoFiltros: boolean = false;
  public equipamentosMapa: any = [];
  private paradasMarkers: Record<number, Marker> = {};
  public operacao!: Operacao;
  public fazendas!: Fazendas;
  public equipamentos!: Equipamentos;
  public mapasDisponiveis: MapaDisponivel[] = [];
  public alteracaoEstadoOperacao!: OperacaoPusher;
  public ofensoresProdutividade: OfensorProdutividade = {};
  public geojsonTalhoes!: GeoJSON.FeatureCollection;
  public filtrosAplicados: any;
  public anoMesTaxasJaCarregadas: any = {}
  public geojsonTaxas: any = {}
  public informacoesEquipamentoSelecionadoNaoEncontrado: { mensagem: string, vc_frota: string } | null = null;
  private readonly CAMPOS_OPERACIONAIS: { labelKey: string, chave: string, cor: string }[] = [
    { labelKey: 'COMPONENTS.MAPA.DETAILS_SIDEBAR.operational_labels.planting', chave: 'tempo_plantando', cor: '#004d40' },
    { labelKey: 'COMPONENTS.MAPA.DETAILS_SIDEBAR.operational_labels.justified_stop', chave: 'tempo_parado_justificado', cor: '#9E9D24' },
    { labelKey: 'COMPONENTS.MAPA.DETAILS_SIDEBAR.operational_labels.unjustified_stop', chave: 'tempo_parado_nao_justificado', cor: '#D32F2F' },
    { labelKey: 'COMPONENTS.MAPA.DETAILS_SIDEBAR.operational_labels.maneuver', chave: 'tempo_manobra', cor: '#FBC02D' },
    { labelKey: 'COMPONENTS.MAPA.DETAILS_SIDEBAR.operational_labels.displacement', chave: 'tempo_deslocamento', cor: '#E64A19' }
  ];
  public mapasDisponivesPadrao = [
    {
      label: 'Rastros',
      tipo: 'rastros',
    },
    {
      label: 'Falhas',
      tipo: 'falhas',
    },
    {
      label: 'Velocidade',
      tipo: 'velocidade',
    }
  ];

  public indicadorVelocidade: { abaixo: number, ideal: number, acima: number } = { abaixo: 0, ideal: 0, acima: 0 };

  public get coresVelocidade(): VelocidadeIdeal {
    return this.velocidadeIdealService.obterValorAtual();
  }

  public segmentosVelocidade(): { label: string, valor: number, cor: string }[] {
    return [
      { label: 'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.velocidade_abaixo', valor: this.indicadorVelocidade.abaixo, cor: this.coresVelocidade.vc_cor_abaixo_minimo },
      { label: 'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.velocidade_ideal', valor: this.indicadorVelocidade.ideal, cor: this.coresVelocidade.vc_cor_ideal },
      { label: 'COMPONENTS.MAPA.DIALOGS.MAP_TYPE.velocidade_acima', valor: this.indicadorVelocidade.acima, cor: this.coresVelocidade.vc_cor_acima_maximo }
    ];
  }

  public geoJsonCombinado: any = {
    shape: {
      "type": "FeatureCollection",
      "features": []
    },
    linhas: {
      "type": "FeatureCollection",
      "features": []
    }
  }

  public readonly tiposMapaValoresMapeaveis: any = {
    rastros: {
      cores: {
        plantando: '#0cda28',
        manobrando: '#FF5B5B',
        deslocando: '#2D9CDB'
      },
      nomeCampo: "tipo"
    },
    falhas: {
      cores: {
        "0": '#D0312D',
        "1": '#D0FFCB'
      },
      nomeCampo: "controleFalha"
    },
    taxas: {
      cores: {
        acima_ideal: '#00FF7F',
        entre_mediana_e_ideal: '#3BCA6D',
        mediana: '#77945C',
        entre_minimo_e_mediana: '#B25F4A',
        abaixo_minimo: '#ED2938',
        indefinida: '#A3A3A3'
      },
      nomeCampo: "categoria"
    }
  }

  public getMapTypeLabel(mapa: MapaDisponivel): string {
    const key = `COMPONENTS.MAPA.DIALOGS.MAP_TYPE.types.${mapa.tipo}`;
    const translated = this.translocoService.translate(key);
    return translated !== key ? translated : mapa.label;
  }

  constructor(
    private readonly compartilhamentoService: CompartilhamentoService,
    private readonly equipamentoService: EquipamentoService,
    private readonly datetimeService: DatetimeService,
    private readonly operacaoService: OperacaoService,
    private readonly fazendaService: FazendaService,
    private readonly sidebarService: SidebarService,
    private readonly websocketService: WebsocketService,
    private readonly mapaService: MapaService,
    private readonly s3Service: S3Service,
    private readonly dialog: MatDialog,
    private translocoService: TranslocoService,
    private popupBuilder: EquipamentoPopupBuilder,
    private readonly trator3dService: Trator3dService,
    private readonly mapaCamadasService: MapaCamadasService,
    private readonly velocidadeIdealService: VelocidadeIdealService,
    private readonly environmentInjector: EnvironmentInjector,
    private readonly appRef: ApplicationRef,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.inscreverEventoWebsocket();

    const hoje = new Date();
    const dataInicio = new Date(hoje);
    dataInicio.setMonth(dataInicio.getMonth() - 1);
    const dataFim = hoje;

    this.filtrosAplicados = {
      clienteId: Number(this.clienteId),
      dataInicio,
      dataFim,
      operacaoId: this.operacaoId
    };

    this.buscarEquipamentos();
    this.buscarTalhoes();
    this.buscarMapasDisponiveis(this.operacaoId);
    this.inscreverEmAtualizacoesDeLegendas();
    this.monitorarExpansaoSidebar();

    this.mapasDisponiveis = this.mapasDisponivesPadrao;

    this.velocidadeIdealService.buscar().subscribe();

    this.velocidadeIdealService.velocidadeIdeal$.subscribe(() => {
      if (this.tipoMapaSelecionado.value === 'velocidade' && this.geojsonTaxas['velocidade']) {
        const coloreado = this.colorirGeojsonPelaAdequadacao(this.geojsonTaxas['velocidade']);
        this.desenharGeojsonTaxas(coloreado);
        this.indicadorVelocidade = this.calcularIndicadorVelocidade(coloreado);
      }
    });
  }

  ngOnDestroy() {
    this.fecharConexaoWebsocket();
    this.trator3dService.destruir();
    if (this.map && this.onZoom) this.map.off('zoom', this.onZoom);
    this.destruirVelocimetro();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.map = new Map({
      container: 'map',
      style: this.mapStyle,
      center: this.center,
      zoom: this.zoom,
      accessToken: this.mapboxAccessToken,
      attributionControl: false,
      pitch: this.currentPitch
    });

    this.map.on('pitchend', (e: any) => {
      if (e.originalEvent) {
        this.currentPitch = this.map.getPitch();
      }
    });

    this.onZoom = () => this.redimensionarParadas();
    this.map.on('zoom', this.onZoom);

    this.trator3dService.tratorClicado$
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ vc_frota, geolocalizacao }) => {
        this.obterInformacoesEquipamento(vc_frota, geolocalizacao);
      });

    this.mapaCamadasService.camadas$
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => this.aplicarVisibilidadeCamadas(config));

    this.tipoMapaSelecionado.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(tipo => {
        if (tipo === 'rastros') {
          this.buscarParadasDoMapa();
        } else {
          this.limparParadasMapa();
        }
        if (tipo !== 'velocidade') this.destruirVelocimetro();
      });

    this.map.on('load', () => {
      this.trator3dService.inicializar(this.map);

      const popupTalhao = new Popup({
        closeButton: false,
        closeOnClick: false,
        className: 'popup-shape'
      });

      const popupTaxas = new Popup({
        closeButton: false,
        closeOnClick: false,
        className: 'popup-taxas'
      });

      const popupVelocidade = new Popup({
        closeButton: false,
        closeOnClick: false,
        className: 'popup-velocidade'
      });
      this.popupVelocidade = popupVelocidade;
      this.map.on('mouseenter', 'shape-layer', (e) => {
        this.map.getCanvas().style.cursor = 'pointer';

        const feature = e.features![0] ?? '';
        const fazenda = feature ? feature.properties!['FAZENDA'] : '';
        const talhao = feature ? feature.properties!['TALHAO'] : '';
        const html = `
          <strong>${this.translocoService.translate('COMPONENTS.MAPA.HOVER_AREA.farm')}:</strong> ${fazenda}<br>
          <strong>${this.translocoService.translate('COMPONENTS.MAPA.HOVER_AREA.field')}:</strong> ${talhao}
        `;

        popupTalhao
          .setLngLat(e.lngLat)
          .setHTML(html)
          .addTo(this.map);
      });


      this.map.on('mousemove', 'shape-layer', (e) => {
        popupTalhao.setLngLat(e.lngLat);
      });

      this.map.on('mouseleave', 'shape-layer', () => {
        this.map.getCanvas().style.cursor = '';
        popupTalhao.remove();
      });

      this.map.on('mouseenter', 'taxas-layer', (e) => {
        if (['rastros', 'falhas', 'velocidade'].includes(this.tipoMapaSelecionado.value!)) return;
        this.map.getCanvas().style.cursor = 'pointer';

        const feature = e.features![0];
        const html = this.montarHtmlPopupTaxa(feature?.properties ?? {});

        popupTaxas
          .setLngLat(e.lngLat)
          .setHTML(html)
          .addTo(this.map);
      });

      this.map.on('mousemove', 'taxas-layer', (e) => {
        if (['rastros', 'falhas', 'velocidade'].includes(this.tipoMapaSelecionado.value!)) return;
        popupTaxas.setLngLat(e.lngLat);
      });

      this.map.on('mouseleave', 'taxas-layer', () => {
        if (['rastros', 'falhas', 'velocidade'].includes(this.tipoMapaSelecionado.value!)) return;
        this.map.getCanvas().style.cursor = '';
        popupTaxas.remove();
      });

      this.map.on('mouseenter', 'taxas-layer', (e) => {
        if (this.tipoMapaSelecionado.value !== 'velocidade') return;
        this.map.getCanvas().style.cursor = 'pointer';
        this.exibirVelocimetro(e);
      });

      this.map.on('mousemove', 'taxas-layer', (e) => {
        if (this.tipoMapaSelecionado.value !== 'velocidade') return;
        this.exibirVelocimetro(e);
      });

      this.map.on('mouseleave', 'taxas-layer', () => {
        if (this.tipoMapaSelecionado.value !== 'velocidade') return;
        this.map.getCanvas().style.cursor = '';
        this.destruirVelocimetro();
      });

      this.map.on('click', 'shape-layer', (e) => {
        const feature = e.features?.[0];
        if (!feature) return;

        this.moverParaTalhao(feature);
      });
    });

    this.carregarShapesDoMapa();
    this.cdr.detectChanges();
  }

  private calcularBounds(feature: GeoJSON.Feature): LngLatBounds | null {
    const geometry = feature.geometry;

    if (!geometry || (geometry.type !== 'Polygon' && geometry.type !== 'MultiPolygon')) {
      return null;
    }

    const coords: [number, number][] =
      geometry.type === 'Polygon'
        ? (geometry.coordinates[0] as [number, number][])
        : (geometry.coordinates[0][0] as [number, number][]);

    if (!coords.length) return null;

    return coords.reduce(
      (bounds, coord) => bounds.extend(coord),
      new LngLatBounds(coords[0], coords[0])
    );
  }

  public exibirVelocimetro(e: { lngLat: any; features?: any[] }): void {
    const feature = e.features?.[0];
    if (!feature || !this.popupVelocidade) return;

    const propriedades = feature.properties ?? {};
    const faixa = this.velocidadeIdealService.obterValorAtual();
    const jaExistiaComponente = !!this.velocimetroComponentRef;

    if (!this.velocimetroComponentRef) {
      this.velocimetroComponentRef = createComponent(VelocimetroMapaComponent, {
        environmentInjector: this.environmentInjector
      });
      this.appRef.attachView(this.velocimetroComponentRef.hostView);
    }

    const instancia = this.velocimetroComponentRef.instance;
    instancia.velocidade = propriedades['velocidade'] ?? 0;
    instancia.velocidadeMinima = faixa.fl_minimo;
    instancia.velocidadeMaxima = faixa.fl_maximo;
    instancia.corAbaixo = faixa.vc_cor_abaixo_minimo;
    instancia.corIdeal = faixa.vc_cor_ideal;
    instancia.corAcima = faixa.vc_cor_acima_maximo;
    instancia.dataUtc = propriedades['dataUtc'] ?? '';
    instancia.horaUtc = propriedades['horaUtc'] ?? '';
    this.velocimetroComponentRef.changeDetectorRef.detectChanges();

    this.popupVelocidade.setLngLat(e.lngLat);
    if (!jaExistiaComponente) {
      this.popupVelocidade
        .setDOMContent(this.velocimetroComponentRef.location.nativeElement)
        .addTo(this.map);
    }
  }

  public destruirVelocimetro(): void {
    this.popupVelocidade?.remove();

    if (this.velocimetroComponentRef) {
      this.appRef.detachView(this.velocimetroComponentRef.hostView);
      this.velocimetroComponentRef.destroy();
      this.velocimetroComponentRef = null;
    }
  }

  private volarParaGeojson(geojson: GeoJSON.FeatureCollection): void {
    const coordenadas: [number, number][] = [];
    geojson.features.forEach((feature: any) => {
      const geo = feature.geometry;
      if (!geo) return;
      if (geo.type === 'LineString') coordenadas.push(...geo.coordinates);
      else if (geo.type === 'MultiLineString') geo.coordinates.forEach((l: any) => coordenadas.push(...l));
      else if (geo.type === 'Polygon') coordenadas.push(...geo.coordinates[0]);
      else if (geo.type === 'MultiPolygon') geo.coordinates.forEach((p: any) => coordenadas.push(...p[0]));
      else if (geo.type === 'Point') coordenadas.push(geo.coordinates);
    });
    if (!coordenadas.length) { return; }
    const bounds = coordenadas.reduce(
      (b, c) => b.extend(c),
      new LngLatBounds(coordenadas[0], coordenadas[0])
    );
    this.map.fitBounds(bounds, { padding: 60, duration: 1500, pitch: this.currentPitch });
  }

  private moverParaTalhao(feature: GeoJSON.Feature): void {
    const bounds = this.calcularBounds(feature);
    if (!bounds) return;

    this.map.fitBounds(bounds, {
      padding: MAP_ANIMATION.padding,
      duration: MAP_ANIMATION.duration,
      maxZoom: MAP_ANIMATION.maxZoom,
      pitch: this.currentPitch
    });
  }

  public moveParaLocalizacao(geolocalizacao: number[]): void {
    this.map.flyTo({
      center: [geolocalizacao[1], geolocalizacao[0]],
      zoom: MAP_ANIMATION.zoom,
      duration: MAP_ANIMATION.duration,
      pitch: this.currentPitch,
      essential: true
    });
  }

  public desenharEquipamentoMapa(equipamentos: Equipamentos): void {
    let capitalize: CapitalizePipe = new CapitalizePipe();
    let removeCharEspeciais: RemoverCaractersEspeciaisPipe = new RemoverCaractersEspeciaisPipe();
    if (this.equipamentosMapa.length != 0) {
      this.equipamentosMapa.forEach((equipamento: Marker) => {
        equipamento.remove();
      })
      this.equipamentosMapa = [];
    }
    const plantadoras = equipamentos.filter(
      e => e.en_tipo === 'plantadora' && this.validarGeolocalizacao(e.gm_geolocalizacao_atual)
    );
    this.trator3dService.atualizar(plantadoras);

    equipamentos.forEach((equipamento: Equipamento) => {
      if (!this.validarGeolocalizacao(equipamento.gm_geolocalizacao_atual)) {
        return;
      }
    })
  }

  public translateStatus(status?: string, bl_ativo?: number): string {
    const t = (key: string) => this.translocoService.translate(key);

    if (!status) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.no_data');
    if (bl_ativo === 0) return t('COMPONENTS.EQUIPAMENTOS.inactive');

    const value = String(status)
      .toLowerCase()
      .replace(/[-_]/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    if (value.includes('trabal')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.working');
    if (value.includes('parado') && value.includes('just')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.justified_stop');
    if (value.includes('parado') && (value.includes('nao') || value.includes('nao'))) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.unjustified_stop');
    if (value.includes('parado')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.stopped');
    if (value.includes('sinal')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.no_signal');
    if (value.includes('desconect')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.disconnected');
    if (value.includes('offline')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.offline');
    if (value.includes('plant')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.planting');
    if (value.includes('manobr')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.maneuvering');
    if (value.includes('desloc')) return t('COMPONENTS.MAPA.EQUIPMENT.statuses.displacement');
    if (value.includes('ativo')) return t('COMPONENTS.EQUIPAMENTOS.active');

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  public redimencionarEquipamento(equipamentoHtml: HTMLElement): void {
    const zoom = this.map.getZoom();

    const size = Math.min(
      300,
      Math.max(20, 10 * Math.pow(1.2, zoom))
    );

    equipamentoHtml.style.width = size + 'px';
    equipamentoHtml.style.height = size + 'px';

    const tag = equipamentoHtml.querySelector('div > .tag') as HTMLElement;
    if (tag) {
      tag.style.setProperty('--tamanho-tag', `${size < 25 ? size / 2 : size / 3}`);
      tag.style.height = `${size < 25 ? size / 4 : size / 6}px`;
      tag.style.fontSize = `${size > 90 ? size / 7 : size / 6}px`;
    }
  }

  public inscreverEventoWebsocket(): void {
    this.eventoSub = this.websocketService.inscreverEvento(WebsocketTipo.Public, this.CANAL, this.EVENTO)
      .subscribe(dadosRecebidos => {
        if (dadosRecebidos) {
          this.processarDadosWebsocket(dadosRecebidos);
        }
      });
  }

  public processarDadosWebsocket(mensagem: any): void {
    if (!mensagem || !mensagem.tipo_evento) {
      return;
    }

    const handlers: Record<string, (msg: any) => void> = {
      'atualizacao_autonomia_insumo': this.atualizarAutonomiaInsumos.bind(this),
      'alteracao_estado_operacao': this.atualizarEstadoOperacao.bind(this),
      'atualizacao_posicao_equipamento': this.atualizarPosicaoEquipamento.bind(this),
      'alteracao_status_equipamento': this.atualizarStatusEquipamento.bind(this),
      'apontamento_parada': this.processarApontamentoParada.bind(this),
      'finalizacao_parada': this.processarFinalizacaoParada.bind(this),
    };

    const handler = handlers[mensagem.tipo_evento];

    if (handler) {
      queueMicrotask(() => handler(mensagem));
    } else {
      console.warn(`[WS] tipo_evento="${mensagem.tipo_evento}" sem handler registrado`);
    }
  }

  public buscarFiltroOperacao(): number | null {
    return Number(localStorage.getItem('operacaoId')) || null;
  }

  public buscarEquipamentos(): void {
    if (this.filtrosAplicados?.operacaoId) {
      this.carregandoEquipamentos = true;
      this.operacaoService.buscarEquipamentosMapa(this.filtrosAplicados?.operacaoId!, this.filtrosAplicados.dataInicio.toISOString(), this.filtrosAplicados.dataFim.toISOString()).subscribe({
        next: (operacao) => {
          operacao.equipamentos = operacao.equipamentos!.filter((equipamento: Equipamento) => equipamento.gm_geolocalizacao_atual !== null);
          this.operacao = operacao;
          this.equipamentos = operacao.equipamentos;
          this.carregandoEquipamentos = false;
          this.desenharEquipamentoMapa(this.equipamentos);
        },
        error: () => {
          this.carregandoEquipamentos = false;
        }
      });
    } else {
      this.operacao = {
        en_estado: 'em_andamento',
        vc_service_id: 'vazio',
        equipamentos: []
      };
      if (this.equipamentosMapa.length != 0) {
        this.equipamentosMapa.forEach((equipamento: Marker) => {
          equipamento.remove();
        })
        this.equipamentosMapa = [];
      }
    }
  }

  public buscarTalhoes(): void {
    if (this.clienteId) {
      this.carregandoTalhoes = true;
      this.fazendaService.buscarFazendaTalhoes(Number(this.clienteId)).subscribe({
        next: (fazendaTalhoes) => {
          this.fazendas = fazendaTalhoes;
          this.carregandoTalhoes = false;
        },
        error: () => {
          this.carregandoTalhoes = false;
        }
      });
    }
  }

  public formatarCoordenadas(coordenadas: number[] | "" | undefined): [number, number] | undefined {
    if (Array.isArray(coordenadas) && coordenadas.length === 2) {
      return coordenadas as [number, number];
    }
    return undefined;
  }


  public atualizarAutonomiaInsumos(mensagem: AutonomiasPusher): void {
    this.atualizacaoAutonomiaInsumo = mensagem;
  }

  public atualizarEstadoOperacao(mensagem: OperacaoPusher): void {
    this.alteracaoEstadoOperacao = mensagem;
  }

  private atualizarStatusEquipamento(mensagem: AlteracaoStatusEquipamentoPusher): void {
    const equipamento = this.equipamentos?.find(e => e.sr_id === mensagem.sr_id);
    if (!equipamento) return;
    equipamento.status_atual = mensagem.status;
    this.rerenderizarTratores();
  }

  private processarApontamentoParada(mensagem: ApontamentoParadaPusher): void {
    if (this.tipoMapaSelecionado.value !== 'rastros') return;
    const equipamento = this.equipamentos?.find(e => e.vc_frota === mensagem.frota);
    if (!equipamento?.sr_id) return;
    this.idParadaParaSrId[mensagem.idParada] = equipamento.sr_id;

    if (mensagem.longitude != null && mensagem.latitude != null) {
      this.adicionarMarkerParada({
        sr_id: 0,
        id_parada: mensagem.idParada,
        fk_equipamento: equipamento.sr_id,
        fk_motivo_parada: null,
        ts_iniciada_em: new Date().toISOString(),
        ts_finalizada_em: null,
        bl_foi_finalizada: false,
        longitude: mensagem.longitude,
        latitude: mensagem.latitude,
        vc_frota: mensagem.frota,
        en_tipo: mensagem.tipoEquipamento,
        motivo_descricao: mensagem.motivoParada,
        motivo_categoria: null,
      });
    }
  }

  private processarFinalizacaoParada(mensagem: FinalizacaoParadaPusher): void {
    const marker = this.paradasMarkers[mensagem.idParada];
    if (marker) {
      marker.remove();
      delete this.paradasMarkers[mensagem.idParada];
    }

    const equipamento = this.equipamentos?.find(e => e.sr_id === mensagem.srIdEquipamento);
    if (!equipamento) return;
    equipamento.status_atual = undefined;
    this.rerenderizarTratores();
  }

  private rerenderizarTratores(): void {
    const plantadoras = this.equipamentos?.filter(
      e => e.en_tipo === 'plantadora' && this.validarGeolocalizacao(e.gm_geolocalizacao_atual)
    ) ?? [];
    this.trator3dService.atualizar(plantadoras);
  }

  public atualizarPosicaoEquipamento(mensagem: PosicaoEquipamentoPusher): void {
    const equipamento = this.equipamentos?.find(e => e.sr_id === mensagem.sr_id);
    if (!equipamento) {
      console.warn(`[WS] atualizarPosicaoEquipamento: sr_id=${mensagem.sr_id} não encontrado em this.equipamentos`);
      return;
    }

    this.trator3dService.atualizarPosicaoEquipamento(mensagem.sr_id, mensagem.geolocalizacao);
  }

  public fecharConexaoWebsocket(): void {
    if (this.eventoSub) {
      this.eventoSub.unsubscribe();
      this.websocketService.cancelarInscricaoCanal(WebsocketTipo.Public, this.CANAL);
    }
  }

  public aplicarFiltros(filtros: any): void {
    this.carregandoFiltros = true;

    const clienteAnterior = this.filtrosAplicados?.clienteId ?? Number(this.clienteId);
    this.filtrosAplicados = filtros;

    if (filtros.clienteId && filtros.clienteId !== clienteAnterior) {
      this.limparMapa();
    }

    this.anoMesTaxasJaCarregadas = {};
    this.geojsonTaxas = {};
    this.removerLayersSources('taxas');

    this.clienteId = filtros.clienteId?.toString() ?? this.clienteId;

    this.carregarOfensoresProdutividade();
    this.buscarEquipamentos();
    this.buscarParadasDoMapa();
    this.buscarTalhoes();
    this.carregarShapesDoMapa();
    this.mudarTaxaSelecionada();

    this.carregandoMapasDisponiveis = true;
    this.buscarMapasDisponiveis(this.filtrosAplicados.operacaoId);
    this.operacaoId = this.filtrosAplicados?.operacaoId;
  }

  private limparParadasMapa(): void {
    Object.values(this.paradasMarkers).forEach((marker: Marker) => marker.remove());
    this.paradasMarkers = {};
  }

  public limparMapa(): void {
    if (this.equipamentosMapa.length > 0) {
      this.equipamentosMapa.forEach((marker: Marker) => marker.remove());
      this.equipamentosMapa = [];
    }

    if (this.popupAtual) {
      this.popupAtual.remove();
      this.popupAtual = null;
    }

    this.limparParadasMapa();

    this.operacao = { en_estado: 'em_andamento', vc_service_id: 'vazio', equipamentos: [] };
    this.equipamentos = [];

    this.removerLayersSources('shape');
    this.removerLayersSources('linhas');
    this.removerLayersSources('taxas');

    this.geojsonTaxas = {};
    this.anoMesTaxasJaCarregadas = {};
    this.geojsonTalhoes = undefined!;
    this.fazendas = undefined!;
    this.ofensoresProdutividade = {};

    this.geoJsonCombinado = {
      shape: { type: 'FeatureCollection', features: [] },
      linhas: { type: 'FeatureCollection', features: [] }
    };
  }

  private buscarParadasDoMapa(): void {
    if (this.tipoMapaSelecionado.value !== 'rastros') return;
    if (!this.filtrosAplicados?.clienteId) return;

    this.limparParadasMapa();

    this.mapaService.buscarParadasDoMapa(
      this.filtrosAplicados.clienteId,
      this.filtrosAplicados.fazendaId,
      this.filtrosAplicados.operacaoId,
      this.filtrosAplicados.dataInicio?.toISOString(),
      this.filtrosAplicados.dataFim?.toISOString(),
    ).pipe(takeUntil(this.destroy$)).subscribe({
      next: (paradas) => this.desenharParadasMapa(paradas),
    });
  }

  private desenharParadasMapa(paradas: ParadaMapa[]): void {
    paradas.forEach(parada => this.adicionarMarkerParada(parada));
  }

  private calcularTamanhoParada(zoom: number): number {
    return Math.max(8, Math.min(30, 5 * Math.pow(2, (zoom - 12) * 0.8)));
  }

  private redimensionarParadas(): void {
    const size = this.calcularTamanhoParada(this.map.getZoom());
    Object.values(this.paradasMarkers).forEach(marker => {
      const el = marker.getElement();
      el.style.width = `${size}px`;
      el.style.height = `${size}px`;
    });
  }

  private aplicarVisibilidadeCamadas(config: ConfiguracaoCamadasMapa): void {
    this.aplicarVisibilidadeParadas(config.stops);
    this.trator3dService.definirVisivel(config.tractors);
    this.aplicarVisibilidadeFazendas(config.farms);
    this.reconstruirFiltroTaxas();
  }

  private aplicarVisibilidadeParadas(visivel: boolean): void {
    Object.values(this.paradasMarkers).forEach(marker => {
      marker.getElement().style.display = visivel ? '' : 'none';
    });
  }

  private aplicarVisibilidadeFazendas(visivel: boolean): void {
    const visibility = visivel ? 'visible' : 'none';
    if (this.map.getLayer('shape-layer')) {
      this.map.setLayoutProperty('shape-layer', 'visibility', visibility);
    }
    if (this.map.getLayer('shape-outline')) {
      this.map.setLayoutProperty('shape-outline', 'visibility', visibility);
    }
  }

  private adicionarMarkerParada(parada: ParadaMapa): void {
    const justificada = parada.motivo_descricao != null;
    const cor = justificada ? '#FF8C00' : '#CC0000';
    const size = this.calcularTamanhoParada(this.map.getZoom());

    const el = document.createElement('div');
    el.style.cssText = `width:${size}px;height:${size}px;background:${cor};border-radius:2px;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,.5);`;
    if (!this.mapaCamadasService.obterConfiguracaoAtual().stops) {
      el.style.display = 'none';
    }

    const popup = new Popup({ offset: 10, closeButton: false, maxWidth: '260px' })
      .setHTML(this.montarHtmlPopupParada(parada));

    const marker = new Marker({ element: el })
      .setLngLat([parada.longitude, parada.latitude])
      .setPopup(popup)
      .addTo(this.map);

    el.addEventListener('click', () => marker.togglePopup());

    this.paradasMarkers[parada.id_parada] = marker;
  }

  private montarHtmlPopupParada(parada: ParadaMapa): string {
    const inicio = parada.ts_iniciada_em
      ? new Date(parada.ts_iniciada_em).toLocaleString('pt-BR')
      : '—';
    const motivo = parada.motivo_descricao ?? 'Não justificada';
    const status = parada.bl_foi_finalizada ? 'Finalizada' : 'Em aberto';

    return `
      <div style="font-family:sans-serif;font-size:13px;line-height:1.5">
        <strong>${parada.vc_frota ?? '—'}</strong>
        <div>Início: ${inicio}</div>
        <div>Motivo: ${motivo}</div>
        <div>Status: ${status}</div>
      </div>`;
  }

  public mudarTaxaSelecionada(): void {
    this.filtrosAplicados ??= {
      dataInicio: new Date(),
      dataFim: new Date()
    }

    this.buscarTaxas();
    const tipoSelecionado: string = this.tipoMapaSelecionado.value!;
    if (this.geojsonTaxas[tipoSelecionado]) {
      if (tipoSelecionado === 'velocidade') {
        this.indicadorVelocidade = this.calcularIndicadorVelocidade(this.geojsonTaxas[tipoSelecionado]);
      }
      this.desenharGeojsonTaxas(this.geojsonTaxas[tipoSelecionado]);
      this.aplicarfiltroTaxas();
    }
  }

  private diferencaEntreDoisArrays(arry1: any, arry2: any): any[] {
    const diffMesesJaCarregados = arry1.filter((obj1: any) =>
      !arry2.some((obj2: any) => obj2.mes === obj1.mes && obj2.ano === obj1.ano)
    );

    const diffIntervaloMesesAnos = arry2.filter((obj2: any) =>
      !arry1.some((obj1: any) => obj1.mes === obj2.mes && obj1.ano === obj2.ano)
    );
    return diffMesesJaCarregados.concat(diffIntervaloMesesAnos);
  }

  public colorirGeojsonPelaAdequadacao(geojson: any): any {
    if (this.tipoMapaSelecionado.value === 'velocidade') {
      return this.colorirGeojsonPelaVelocidade(geojson);
    }

    const tiposSemTaxas: string[] = ['rastros', 'falhas'];
    let tipoAtual: string = 'taxas';
    if (tiposSemTaxas.includes(this.tipoMapaSelecionado.value!)) {
      tipoAtual = this.tipoMapaSelecionado.value!
    }
    let valorMapeavel: any = this.tiposMapaValoresMapeaveis[tipoAtual];

    geojson.features.forEach((feature: any) => {
      let tipoMapeavel: string = feature.properties[valorMapeavel.nomeCampo];
      feature.properties.color = valorMapeavel.cores[tipoMapeavel]
    });
    return geojson;
  }

  public colorirGeojsonPelaVelocidade(geojson: any): any {
    const faixa = this.velocidadeIdealService.obterValorAtual();

    geojson.features.forEach((feature: any) => {
      const velocidade = feature.properties['velocidade'];

      if (velocidade < faixa.fl_minimo) {
        feature.properties.color = faixa.vc_cor_abaixo_minimo;
      } else if (velocidade > faixa.fl_maximo) {
        feature.properties.color = faixa.vc_cor_acima_maximo;
      } else {
        feature.properties.color = faixa.vc_cor_ideal;
      }
    });

    return geojson;
  }

  public calcularIndicadorVelocidade(geojson: any): { abaixo: number, ideal: number, acima: number } {
    const faixa = this.velocidadeIdealService.obterValorAtual();
    let distanciaAbaixo = 0;
    let distanciaIdeal = 0;
    let distanciaAcima = 0;

    (geojson?.features ?? []).forEach((feature: any) => {
      const velocidade = feature.properties['velocidade'];
      const distancia = feature.properties['distanciaMetros'] ?? 0;

      if (velocidade < faixa.fl_minimo) {
        distanciaAbaixo += distancia;
      } else if (velocidade > faixa.fl_maximo) {
        distanciaAcima += distancia;
      } else {
        distanciaIdeal += distancia;
      }
    });

    const total = distanciaAbaixo + distanciaIdeal + distanciaAcima;
    if (total === 0) {
      return { abaixo: 0, ideal: 0, acima: 0 };
    }

    return {
      abaixo: Math.round((distanciaAbaixo / total) * 100),
      ideal: Math.round((distanciaIdeal / total) * 100),
      acima: Math.round((distanciaAcima / total) * 100)
    };
  }

  montarHtmlPopupTaxa(properties: any): string {
    const taxa = properties?.['taxaAplicacaoTotal'];
    const taxaFormatada = typeof taxa === 'number' ? taxa.toFixed(2) : '-';
    const categoria = (properties?.['categoria'] ?? '').toString().replace(/_/g, ' ');
    const dataUtc = properties?.['dataUtc'] ?? '';
    const horaUtc = properties?.['horaUtc'] ?? '';

    const ehTaxaDeMuda = (this.tipoMapaSelecionado.value ?? '').startsWith('muda');
    const imagemMuda = ehTaxaDeMuda
      ? `<img style="border-radius: 20px; width: 100%; height: 13rem; backface-visibility: hidden; z-index: -1; margin-bottom: 30px;" src="assets/mapa/taxas/imagem.png" alt="">`
      : '';

    return `
    <div class="card-resumo p-4 bg-white border rounded-3">
    ${imagemMuda}
    <ul class="lista-resumos list-unstyled d-flex flex-column gap-4 m-0 p-0">
      <li class="item-resumo border-bottom pb-3" style="position:relative">
        <section class="d-flex">
          <div>
            <div class="icone-resumo bg-total d-flex justify-content-center align-items-center rounded-4">
              <img src="assets/mapa/taxas/chart.svg" class="icone-img"/>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center gap-2 container-info">
            <span class="texto-label">APLICAÇÃO</span>
            <h4 class="m-0" style="font-size: 1rem; font-weight: 600; color: #1d1d1dff">${taxaFormatada}</h4>
          </div>
        </section>
      </li>

      <li class="item-resumo border-bottom pb-3" style="position: relative;">
        <section class="d-flex">
          <div>
            <div class="icone-resumo bg-media d-flex justify-content-center align-items-center rounded-4">
              <img src="assets/mapa/taxas/trendingup.svg" class="icone-img-menor"/>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center gap-2 container-info">
            <span class="texto-label">CATEGORIA</span>
            <h4 class="m-0" style="font-size: 1rem; font-weight: 600; color: #1d1d1dff">${categoria}</h4>
          </div>
        </section>
      </li>

      <li class="item-resumo" style="position: relative;">
        <section class="d-flex">
          <div>
            <div class="icone-resumo bg-quantidade d-flex justify-content-center align-items-center rounded-4">
              <img src="assets/mapa/taxas/hash.svg" class="icone-img-menor"/>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center gap-2 container-info min-width-40">
            <span class="texto-label">DATA / HORA</span>
            <h4 class="m-0" style="font-size: .8rem; font-weight: 600; color: #1d1d1dff">${dataUtc} ${horaUtc}</h4>
          </div>
        </section>
      </li>
    </ul>
    </div>
    `;
  }

  public intervaloParaBuscarMesesEAno(): any[] {
    const intervaloMesesAnos = this.datetimeService.mesesAnoNoIntervalo(
      this.filtrosAplicados.dataInicio,
      this.filtrosAplicados.dataFim
    );
    const tipoSelecionado: string = this.tipoMapaSelecionado.value!;
    const mesesJaCarregados = this.anoMesTaxasJaCarregadas[tipoSelecionado] ?? null;
    const mesesParaCarregar = mesesJaCarregados
      ? this.diferencaEntreDoisArrays(mesesJaCarregados, intervaloMesesAnos)
      : intervaloMesesAnos;

    this.anoMesTaxasJaCarregadas[tipoSelecionado] = [
      ...(this.anoMesTaxasJaCarregadas[tipoSelecionado] ?? []),
      ...mesesParaCarregar
    ];

    return mesesParaCarregar;
  }

  public desenharShapeMapa(shapesGeojson: any, tipo: string): void {
    const nomeParaTipo: any = {
      'shape': 'fill',
      'linhas': 'line'
    }
    shapesGeojson = this.colorirGeojsonPorTipo(shapesGeojson, tipo);
    const tipoGeojson: string = nomeParaTipo[tipo];
    this.desenharGeojsonMapa(shapesGeojson, tipo, tipoGeojson);
    if (tipo === 'shape') {
      this.aplicarVisibilidadeFazendas(this.mapaCamadasService.obterConfiguracaoAtual().farms);
    }
  }


  public criarElementoCliqueEquipamento(equipamento: EquipamentoTelemetria, temposOperacionais: any, geolocalizacao: [number, number]): void {
    const [lat, lng] = geolocalizacao;

    if (this.popupAtual) {
      this.popupAtual.remove();
      this.popupAtual = null;
    }

    const elementoHtml = this.popupBuilder.build(equipamento, temposOperacionais);
    const targetEl = elementoHtml.querySelector('#abrirDialogApontamento');

    if (targetEl) {
      this.addEventoClickEquipamento(targetEl, equipamento);
    }

    this.popupAtual = new Popup({ closeOnClick: true, maxWidth: '600px', offset: 20 })
      .setLngLat([lng, lat])
      .setDOMContent(elementoHtml)
      .addTo(this.map);

    const fecharPopup = () => {
      this.popupAtual?.remove();
      this.popupAtual = null;
    };

    this.map.on('move', fecharPopup);
    this.popupAtual.on('close', () => {
      this.map.off('move', fecharPopup);
      this.popupAtual = null;
    });
  }

  private addEventoClickEquipamento(elementoHtml: Element, informacoesEquipamentoSelecionado: EquipamentoTelemetria): Element {
    elementoHtml?.addEventListener('click', () => {
      this.abrirDialogApontamento(informacoesEquipamentoSelecionado);
    });
    return elementoHtml;
  }

  public desenharGeojsonMapa(geoJson: any, nome: string, tipo: string): void {
    const sourceId: string = `${nome}-source`;
    const lineWidth: number = 1;
    const tiposPaint: any = {
      'fill': {
        'fill-color': ['get', 'color'],
        'fill-opacity': 0.3,
        'fill-antialias': true,
        'fill-outline-color': ['get', 'color']
      },
      'line': {
        'line-color': ['get', 'color'],
        'line-width': {
          'type': 'exponential',
          'base': 2,
          'stops': [
            [0, lineWidth * Math.pow(2, (0 - this.zoom)) * 1],
            [24, lineWidth * Math.pow(2, (24 - this.zoom)) * 1],
          ]
        },
      }
    }

    this.removerLayersSources(nome);

    this.map.addSource(sourceId, {
      type: 'geojson',
      data: geoJson
    });

    this.map.addLayer({
      id: `${nome}-layer`,
      type: tipo as any,
      source: sourceId,
      layout: {},
      paint: tiposPaint[tipo]
    });

    if (tipo == 'fill') {
      this.map.addLayer({
        id: `${nome}-outline`,
        type: 'line',
        source: sourceId,
        paint: {
          'line-color': ['get', 'color'],
          'line-width': 2,
        },
      });
    }
  }

  public desenharGeojsonTaxas(geoJson: any): void {

    // Taxa vem do backend só com dataUtc/horaUtc (um timestamp por segmento);
    // derivamos dataInicioBrt=dataFimBrt para o filtro compartilhado do taxas-layer.
    // Rastro/falha já trazem dataInicioBrt/dataFimBrt do backend — não mexer.
    (geoJson?.features ?? []).forEach((feature: any) => {
      const p = feature.properties ?? {};
      if (p.dataUtc) {
        const dataBrt = this.datetimeService.dataUtcParaBrt(p.dataUtc, p.horaUtc);
        p.dataInicioBrt = dataBrt;
        p.dataFimBrt = dataBrt;
      }
      feature.properties = p;
    });

    const sourceId = 'taxas-source';
    const layerId = 'taxas-layer';
    const lineWidth = 0.09;
    const sourceTaxas = this.map.getSource(sourceId) as GeoJSONSource;
    if (sourceTaxas) {
      sourceTaxas.setData(geoJson);
      return
    }

    this.map.addSource(sourceId, {
      'type': 'geojson',
      'lineMetrics': true,
      'data': geoJson
    });

    this.map.addLayer({
      'id': layerId,
      'type': 'line',
      'source': sourceId,
      'layout': {},
      'paint': {
        'line-color': ['get', 'color'],
        'line-width': {
          'type': 'exponential',
          'base': 2,
          'stops': [
            [0, lineWidth * Math.pow(2, (0 - this.zoom)) * 1],
            [24, lineWidth * Math.pow(2, (24 - this.zoom)) * 1],
          ]
        },
      }
    });
  }

  public buscarTaxas(): void {
    let clienteId = this.filtrosAplicados?.clienteId ?? this.clienteId;
    const tipoSelecionado: string = this.tipoMapaSelecionado.value!;
    if (this.filtrosAplicados && String(clienteId) !== String(this.clienteId)) {
      this.anoMesTaxasJaCarregadas = {};
      this.geojsonTaxas = {};
    }
    this.clienteId = String(clienteId);
    const taxasTipos: string[] = [
      'muda_ton_ha',
      'muda_tol_m',
      'liquido_1',
      'liquido_2',
      'liquido_3',
      'solido_1',
      'solido_2',
      'solido_3',
      'profundidade'
    ];

    let arquivos!: Arquivos;
    const mesesParaCarregar: any[] = this.intervaloParaBuscarMesesEAno();
    if (mesesParaCarregar.length == 0) return;

    arquivos = mesesParaCarregar.map((mesAno: any) => ({
      vc_caminho_arquivo_s3: `${clienteId}/${tipoSelecionado}/${mesAno.ano}/${mesAno.mes}.geojson`
    } as Arquivo));
    this.s3Service.buscarArquivos(arquivos).then(
      (geoJson: any) => {
        this.geojsonTaxas[tipoSelecionado] ??= {
          "type": "FeatureCollection",
          "features": []
        }
        geoJson.push(this.geojsonTaxas[tipoSelecionado]);
        let geojsonTaxas = this.combinarGeoJson(geoJson);
        this.geojsonTaxas[tipoSelecionado] = this.colorirGeojsonPelaAdequadacao(geojsonTaxas);
        if (tipoSelecionado === 'velocidade') {
          this.indicadorVelocidade = this.calcularIndicadorVelocidade(this.geojsonTaxas[tipoSelecionado]);
        }
        this.desenharGeojsonTaxas(this.geojsonTaxas[tipoSelecionado]);
        this.volarParaGeojson(this.geojsonTaxas[tipoSelecionado]);
        this.aplicarfiltroTaxas();
        this.carregandoFiltros = false;
      }
    ).catch((err) => {
      console.error('[MAPA] erro ao carregar taxas:', err);
      this.carregandoFiltros = false;
    })
  }

  public aplicarfiltroTaxas(): void {
    if (!this.filtrosAplicados) {
      return
    }
    this.reconstruirFiltroTaxas();
    this.carregarShapesDoMapa();
  }

  private reconstruirFiltroTaxas(): void {
    if (!this.filtrosAplicados) {
      return
    }
    let configArray: any[] = [
      'all',
    ]
    const fazendaId: number | undefined = this.filtrosAplicados.fazendaId;
    const operacaoId: number | undefined = this.filtrosAplicados.operacaoId;
    if (fazendaId) {
      configArray.push(['==', ['get', 'fazendaId'], fazendaId]);
    }
    if (operacaoId) {
      configArray.push(['==', ['get', 'operacaoId'], operacaoId]);
    }
    if ((this.filtrosAplicados.dataInicio && this.filtrosAplicados.dataFim)) {
      const dataInicio: string = this.datetimeService.extrairData(this.filtrosAplicados.dataInicio);
      const dataFim: string = this.datetimeService.extrairData(this.filtrosAplicados.dataFim);
      configArray.push(

        ['>=', ['get', 'dataInicioBrt'], dataInicio],
        ['<=', ['get', 'dataFimBrt'], dataFim]

      );
    }
    if (this.tipoMapaSelecionado.value === 'rastros') {
      const camadas = this.mapaCamadasService.obterConfiguracaoAtual();
      const categoriasPorChave: Record<string, boolean> = {
        plantando: camadas.planting_track,
        deslocando: camadas.displacement_track,
        manobrando: camadas.maneuvering_track
      };
      Object.entries(categoriasPorChave).forEach(([categoria, ativa]) => {
        if (!ativa) {
          configArray.push(['!=', ['get', 'tipo'], categoria]);
        }
      });
    }
    if (this.map.getLayer('taxas-layer')) {
      this.map.setFilter('taxas-layer', configArray);
    }
  }

  public carregarOfensoresProdutividade(): void {
    let informacoesFiltradas: any = this.filtrosAplicados;
    this.mapaService
      .buscarOfensoresProdutividade(
        informacoesFiltradas.clienteId,
        informacoesFiltradas.fazendaId,
        informacoesFiltradas.operacaoId,
        informacoesFiltradas.dataInicio.toISOString().split("T")[0],
        informacoesFiltradas.dataFim.toISOString().split("T")[0]
      )
      .pipe(
        finalize(() => {
          this.carregandoOfensoresProdutividade = false;
        })
      )
      .subscribe({
        next: (response: OfensorProdutividade) => {
          if (response) {
            this.ofensoresProdutividade = response;
          }
        },
        error: () => {
          this.ofensoresProdutividade = {};
        },
      });
  }
  public carregarShapesDoMapa(): void {
    const clienteId: number = this.filtrosAplicados
      ? this.filtrosAplicados.clienteId
      : Number.parseInt(localStorage.getItem('clienteId')!);

    if (clienteId === this.clienteIdShapesCarregado) {
      return;
    }

    this.clienteIdShapesCarregado = clienteId;
    this.carregandoShapes = true;

    this.fazendaService.buscarFazendasPorCliente(clienteId).subscribe({
      next: (response: any) => {
        const shapesData = Array.isArray(response) ? [] : response?.shapes ?? [];
        const shapes = shapesData
          .filter((s: any) => s.vc_sha1)
          .map((s: any) => this.s3Service.buscarShapeCliente(s.vc_sha1));

        if (!shapes.length) {
          this.carregandoShapes = false;
          this.carregandoFiltros = false;
          return;
        }

        Promise.all(shapes).then((geoJsons: any[]) => {
          const geojsonCombinado = this.combinarGeoJson(geoJsons);
          this.geojsonTalhoes = geojsonCombinado;
          this.desenharShapeMapa(geojsonCombinado, 'shape');
          this.carregandoFiltros = false;
          this.carregandoShapes = false;
        }).catch(() => {
          this.clienteIdShapesCarregado = null;
          this.carregandoFiltros = false;
          this.carregandoShapes = false;
        });
      },
      error: () => {
        this.clienteIdShapesCarregado = null;
        this.carregandoFiltros = false;
        this.carregandoShapes = false;
      }
    });
  }

  public buscarArquivosS3(arquivosPorTipo: any): void {
    this.carregandoShapes = true;
    Object.keys(this.geoJsonCombinado).forEach((tipo: string) => {
      const arquivos: Arquivos = arquivosPorTipo[tipo];
      if (!arquivos || !Array.isArray(arquivos)) {
        return;
      }

      this.s3Service.buscarArquivos(arquivos).then((geoJson: any) => {
        const geojsonCombinado = this.combinarGeoJson(geoJson);

        if (tipo === 'shape') {
          this.geojsonTalhoes = geojsonCombinado;
        }
        this.desenharShapeMapa(geojsonCombinado, tipo);
        this.carregandoFiltros = false;
        this.carregandoShapes = false;
      }).catch(() => {
        this.carregandoFiltros = false;
        this.carregandoShapes = false;
      });
    });
  }

  public onTalhaoSelecionado(talhao: any): void {
    const feature = this.geojsonTalhoes?.features.find(
      f => String(f.properties?.['TALHAO']) === String(talhao?.vc_nome)
    );
    if (feature) {
      this.moverParaTalhao(feature);
    }
  }

  public colorirGeojsonPorTipo(geojson: any, tipo: string): any {
    const tipos: any = {
      shape: '#FFFF99',
      linhas: '#00F900'
    }

    geojson.features.forEach((feature: any) => {
      feature.properties.color = tipos[tipo];
    });
    return geojson;
  }

  private combinarGeoJson(geoJsonArray: any[]): any {
    return {
      "type": "FeatureCollection",
      "features": geoJsonArray.flatMap(geojson => geojson.features)
    }
  }

  public obterInformacoesEquipamento(vc_frota: string, geolocalizacao: [number, number]): void {
    this.carregandoInformacoesDoEquipamento = vc_frota;
    const temposOperacionais: { label: string, valor: number, cor: string }[] = [];
    this.equipamentoService.buscarInformacaoesEquipamento(vc_frota, Number(this.clienteId))
      .pipe(finalize(() => { this.equipamentoLoading = false; }))
      .subscribe({
        next: (resposta: EquipamentoTelemetria) => {
          if (resposta) {
            const informacoesEquipamentoSelecionado: EquipamentoTelemetria = this.normalizarInformacoesEquipamento(resposta);
            this.CAMPOS_OPERACIONAIS.forEach(campo => {
              const valorCampo: number | undefined = (informacoesEquipamentoSelecionado?.tempos_operacionais as any)[campo.chave];
              const valor = (valorCampo == null) ? 0 : valorCampo;
              const label = this.translocoService.translate(campo.labelKey);
              temposOperacionais.push({ label: label, valor: valor, cor: campo.cor });
            });
            this.criarElementoCliqueEquipamento(informacoesEquipamentoSelecionado, temposOperacionais, geolocalizacao)
            this.carregandoInformacoesDoEquipamento = '';
          } else {
            this.informacoesEquipamentoSelecionadoNaoEncontrado = {
              mensagem: 'Equipamento não possuí mensagem de telemetria.',
              vc_frota: vc_frota
            };
            this.criarElementoComDadosMinimos(vc_frota, geolocalizacao);
            this.carregandoInformacoesDoEquipamento = '';
          }
        },
        error: (erro) => {
          this.criarElementoComDadosMinimos(vc_frota, geolocalizacao);
          this.carregandoInformacoesDoEquipamento = '';
        }
      });
  }

  private criarElementoComDadosMinimos(vc_frota: string, geolocalizacao: [number, number]): void {
    const dadosMinimos: Partial<EquipamentoTelemetria> = {
      vc_frota: vc_frota,
      velocidade: 0,
      nivel_combustivel: 'N/A',
      rpm: 0,
      estado_conexao: 'Sem dados'
    };
    const temposOperacionais: { label: string, valor: number, cor: string }[] = this.CAMPOS_OPERACIONAIS.map(c => ({ label: this.translocoService.translate(c.labelKey), valor: 0, cor: c.cor }));
    this.criarElementoCliqueEquipamento(dadosMinimos as EquipamentoTelemetria, temposOperacionais, geolocalizacao);
  }

  private normalizarInformacoesEquipamento(informacoes: Partial<EquipamentoTelemetria> | any): EquipamentoTelemetria {
    const defaults: any = {
      vc_frota: informacoes?.vc_frota ?? '',
      fk_equipamento: informacoes?.fk_equipamento,
      velocidade: informacoes?.velocidade ?? 0,
      nivel_combustivel: informacoes?.nivel_combustivel ?? 'N/A',
      rpm: informacoes?.rpm ?? 0,
      estado_conexao: informacoes?.estado_conexao ?? 'Sem dados',
      estado_operacao: informacoes?.estado_operacao ?? 'sem_sinal',
      en_tipo: informacoes?.en_tipo ?? '',
      operador_atual: informacoes?.operador_atual ?? '',
      tempos_operacionais: informacoes?.tempos_operacionais ?? {}
    };

    return defaults as EquipamentoTelemetria;
  }

  private getWifiBrokenMarkerHtml(): string {
    return `
      <div style="position:absolute; right:-28%; top:0; display:flex; align-items:center; justify-content:center; width:24%;">
        <div style="position:relative; width:100%; height:0; padding-bottom:100%;">
          <img src="assets/equipamentos/tomada-desconectada-alert.svg" alt="Desconectado" style="position:absolute; inset:0; width:100%; height:100%; object-fit:contain; display:block;">
        </div>
      </div>
    `;
  }

  public abrirDialogApontamento(informacoesEquipamentoSelecionado: EquipamentoTelemetria): void {
    this.dialog.open(DialogApontamentosFormComponent, {
      width: '500px',
      data: {
        apontamento: informacoesEquipamentoSelecionado,
        acao: 'cadastrar'
      }
    });
  }
  public calculaProporcao(valor: number, temposOperacionais: any[]): number {
    const total = temposOperacionais.reduce((total: any, tempo: any) => total + tempo.valor, 0);
    return (valor / total) * 100;
  }

  public buscarMapasDisponiveis(operacaoId: number | null): void {
    let clienteId: number = Number(this.clienteId);

    this.mapaService.buscarMapasDisponiveis(clienteId, operacaoId)
      .subscribe({
        next: (response) => {
          this.mapasDisponiveis = this.mapasDisponivesPadrao;
          this.mapasDisponiveis = Array.isArray(response) ? [...this.mapasDisponiveis, ...response] : this.mapasDisponiveis;
          this.carregandoMapasDisponiveis = false;
        },
        error: () => {
          this.mapasDisponiveis = this.mapasDisponivesPadrao;
          this.carregandoMapasDisponiveis = false;
        }
      });
  }

  public abrirModalEquipamento(): void {
    const modalEstavaAberto = !this.exibirModalEncontrarEquipamento;
    this.exibirModalEncontrarEquipamento = true;
    this.exibirModalEncontrarTalhoes = true;
    this.exportarMapaCalorModal = false;
    this.exibirPainelCamadas = true;
    if (!modalEstavaAberto) {
      this.exibirModalEncontrarEquipamento = false;
    }
  }

  public abrirModalTalhoes(): void {
    const modalEstavaAberto = !this.exibirModalEncontrarTalhoes;
    this.exibirModalEncontrarEquipamento = true;
    this.exibirModalEncontrarTalhoes = true;
    this.exportarMapaCalorModal = false;
    this.exibirPainelCamadas = true;
    if (!modalEstavaAberto) {
      this.exibirModalEncontrarTalhoes = false;
    }
  }

  public abrirPainelCamadas(): void {
    const modalEstavaAberto = !this.exibirPainelCamadas;
    this.exibirModalEncontrarEquipamento = true;
    this.exibirModalEncontrarTalhoes = true;
    this.exportarMapaCalorModal = false;
    this.exibirPainelCamadas = true;
    if (!modalEstavaAberto) {
      this.exibirPainelCamadas = false;
    }
  }

  public alternarModalExportar(): void {
    const modalEstavaAberto = this.exportarMapaCalorModal;
    this.exibirModalEncontrarEquipamento = true;
    this.exibirModalEncontrarTalhoes = true;
    this.exportarMapaCalorModal = false;
    this.exibirPainelCamadas = true;
    if (!modalEstavaAberto) {
      this.exportarMapaCalorModal = true;
    }
  }

  public removerLayersSources(nome: string): void {
    if (this.map.getLayer(`${nome}-layer`)) {
      this.map.removeLayer(`${nome}-layer`);
    }

    if (this.map.getLayer(`${nome}-outline`)) {
      this.map.removeLayer(`${nome}-outline`);
    }

    if (this.map.getSource(`${nome}-source`)) {
      this.map.removeSource(`${nome}-source`);
    }
  }

  public inscreverEmAtualizacoesDeLegendas(): void {
    this.compartilhamentoService.currentData.subscribe(data => {
      this.dialogLegendas = data;
    });
  }

  public monitorarExpansaoSidebar(): void {
    this.sidebarService.isExpanded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isExpanded => {
        if (isExpanded) {
          this.dialogLegendas = true;
        } else {
          this.dialogLegendas = false;
        }
      });
  }

  private validarGeolocalizacao(geolocalizacao: number[] | null | undefined): boolean {
    if (!geolocalizacao || !Array.isArray(geolocalizacao)) {
      return false;
    }

    if (geolocalizacao.length === 2 && geolocalizacao[0] === 0 && geolocalizacao[1] === 0) {
      return false;
    }

    if (!Number.isFinite(geolocalizacao[0]) || !Number.isFinite(geolocalizacao[1])) {
      return false;
    }
    return true;
  }
}
